module.exports = __webpack_public_path__ + "img/Group 74.9ddc6a6f.svg";